// extracted by mini-css-extract-plugin
module.exports = {"content":"ContentLoading__content___FUupZ","compact":"ContentLoading__compact___izicI"};